<template>
  <div>
    <div class="d-flex justify-content-between">
      <h1 class="page-header">{{ $t('cardToBePrint.pageTitle') }}</h1>
      <ts-breadcrumb
        :items="[
          { text: $t('toHomePage'), href: '/' },
          {
            text: $t('cardToBePrint.pageTitle'),
            active: true
          }
        ]"
      />
    </div>
    <ts-card>
      <ts-tabs target="cardToBePrintList">
        <ts-tab>{{ $t('cardToBePrint.newProfile') }}</ts-tab>
        <ts-tab>{{ $t('cardToBePrint.existingProfile') }}</ts-tab>
        <ts-tab>{{ $t('cardToBePrint.allProfile') }}</ts-tab>
      </ts-tabs>
      <ts-tab-panes name="cardToBePrintList">
        <ts-tab-pane>
          <new-profile />
        </ts-tab-pane>
        <ts-tab-pane>
          <existing-profile />
        </ts-tab-pane>
        <ts-tab-pane>
          <all-profile />
        </ts-tab-pane>
      </ts-tab-panes>
    </ts-card>
  </div>
</template>

<script>
import NewProfile from './new-profile'
import ExistingProfile from './existing-profile'
import AllProfile from './all-profile'
export default {
  name: 'card-to-be-print-table',
  components: { NewProfile, ExistingProfile, AllProfile }
}
</script>
